export enum DocFeedbackStatusDB {
  Init = 'init',
  Approved = 'approved',
  Reject = 'reject',
}
